import React, { useEffect, useState } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import apiUrl from "../Apiurl";


function CorreggiUtenti(props) {

    const [utente, setUtente] = useState("");
    const [correzione, setCorrezione] = useState("");

    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();

    const [token, setToken] = useState("");

    useEffect(() => {
        const getUserMetadata = async () => {
     
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
     
        getUserMetadata();


      }, [getAccessTokenSilently, user?.sub]);


    ///// PAGINA

    function handleChangeutente(evt) {
        setUtente(evt.target.value);
    }

    function handleChangeCorrezione(evt) {
        setCorrezione(evt.target.value);
    }

    function submitCorrezione(evt) {
        fetch(apiUrl + "/patch/utente", {
            method: 'PATCH', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+token
            },
            body: JSON.stringify({
                utenteDaCorreggere: utente,
                correzione: correzione
            }),
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }





    return (
        <div className="colonnaTuttaPagina">
        <section className="sfondoBiancoTema pa5 br4 shadow-4 w-50 center ph3 ph5-ns pv5 b--white">
            <article className="mw8 center br2 ba b--white">
                <div className="dt-ns dt--fixed-ns w-100 b--white">
                <form>
                    {/* <fieldset className='b--white'> */}
                        <h2>Correzione nomi utente</h2>
                        
                        <span>Cambia </span><input
                        className="mt3 mb2 db w-30 ba bordoColScrittaDef-20 pa2 br2"
                        type="text"
                        onChange={handleChangeutente}
                        value={utente}
                        autoComplete="off"
                    ></input><span> in </span>
                    <input
                        className="mt3 mb2 db w-30 ba bordoColScrittaDef-20 pa2 br2"
                        type="text"
                        onChange={handleChangeCorrezione}
                        value={correzione}
                        autoComplete="off"
                    ></input>
                </form>
                <br />
                <button onClick={submitCorrezione}>Cambia</button>
                </div>
            </article>
        </section>
        </div>
    )
}

export default CorreggiUtenti;

